import { render, staticRenderFns } from "./Builddevice.vue?vue&type=template&id=1a681f54&scoped=true"
import script from "./Builddevice.vue?vue&type=script&lang=js"
export * from "./Builddevice.vue?vue&type=script&lang=js"
import style0 from "./Builddevice.vue?vue&type=style&index=0&id=1a681f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a681f54",
  null
  
)

export default component.exports